"use strict";

angular.module("common").controller("SelectCustomerController", function ($scope, CustomersService, ModalService) {
  $scope.refresh = function (_id) {
    CustomersService.getSelectArray().then(function (array) {
      $scope.to.options = array;
    });
  };

  $scope.create = function () {
    console.log();
    ModalService.open("customers/customer", {}).then(function (_id) {
      $scope.refresh();
    });
  };

  $scope.reset = function () {
    console.log("reset");

    $scope.model[$scope.options.key] = null;
    $scope.optionName = "";
    $scope.$applyAsync();

    if ($scope.options.templateOptions.refresh) {
      $scope.options.templateOptions.refresh();
    }
  };

  $scope.edit = function () {
    ModalService.open("customers/customer", { _id: _id }).then(function (_id) {
      $scope.refresh(_id);
    });
  };

  $scope.refresh();
});